export enum OrderEntryFormBookedEditEnum {
  NoChanges,
  AllowChanges,
  LineItemsOnly,
}
